import { createSlice } from "@reduxjs/toolkit";
import { saveCategory, deleteCategory } from "./categoryThunks";

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    selectedCategory: null,
    isEditCategory: false,
    successMessage: null,
  },
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setIsEditCategory: (state, action) => {
      state.isEditCategory = action.payload;
    },
    resetCategoryManageStatus: (state) => {
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveCategory.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const { setSelectedCategory, setIsEditCategory, resetCategoryManageStatus } =
  categorySlice.actions;

export default categorySlice.reducer;
